import { makeStyles } from "@fluentui/react-components";
import designTokens from "theme/customTheme";

export const useManageUseCasePromptsStyles = makeStyles({
  truncatedText: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
  },

  useCaseCell: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[2],
    flexWrap: "nowrap",
    overflow: "hidden",
    cursor: "pointer",
  },

  useCaseMoreText: {
    fontSize: designTokens.fontSize.xs,
    color: designTokens.neutral[500],
    fontWeight: designTokens.fontWeight.medium,
    whiteSpace: "nowrap",
  },

  tooltipContent: {
    whiteSpace: "pre-line",
  },

  ownerHeader: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[1],
  },

  infoIcon: {
    cursor: "help",
    color: designTokens.neutral[400],
  },
});
